import React, { Component } from "react";
import { useHistory } from "react-router-dom";
import "../Styles/SvgCommand.css";

const GrowthIcon = (props) => {
  const history = useHistory();
  const handleClick = () => history.push('/home')
  return (
    <svg id="Calque_1" data-name="Calque 1" viewBox="0 0 250.46 250.46" height="400px" width="400px">
      <defs>
        <style>{`.cls-1{fill:url(#linear-gradient);}.cls-2{fill:#e52521;}`}</style>
        <linearGradient id="linear-gradient" x1="179.03" y1="82.46" x2="83.24" y2="178.26" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#3c73b9"/><stop offset="1" stopColor="#084793"/>
        </linearGradient>
      </defs>
      <path className="cls-1" d="M189.29,109.18v-2.24h14.23c-8.41-8.07-16.44-15.79-24.61-23.66l-24.46,23.49h14.11V109c0,15.44-.27,30.89.07,46.33.34,15.07-9.83,24.81-20.62,28.25-14,4.44-26.7,2.12-37.32-8.24a24.59,24.59,0,0,1-7.5-18.19v-9.57h.17V85.15h20.49v62.42h0c0,2.15,0,4.3,0,6.45a12.36,12.36,0,0,0,.19,2,12,12,0,0,0,23,1.94,13.39,13.39,0,0,0,.73-4.39q.07-36.6,0-73.21c0-.51-.05-1-.09-1.61H80v2.13c0,24.76.14,49.5,0,74.25-.13,17.82,7.89,31.1,22.78,40.53,21.85,13.86,52.12,11.46,71.17-5.5,10.13-9,15.42-20.26,15.4-33.81C189.26,140.64,189.29,124.91,189.29,109.18Z"/>
      <path className="cls-2" d="M114,136.44h9.82V85.15H103.36v60.21A10.86,10.86,0,0,1,114,136.44Z"/>
    </svg>
 
  );
};



export default GrowthIcon;
